import { Link } from 'react-router-dom';
import { ContracteumLogo } from 'components/contracteum-logo';
import s from './Header.module.scss';

export function Header() {
  return (
    <div className={s.root}>
      <Link to="/" className={s.logo}>
        <ContracteumLogo variant="auth" />
      </Link>
    </div>
  );
}
